export function findTask(taskList, taskId) {
  if (!taskList)
    return null
  let matchingList = taskList.filter(task => task.taskId === taskId)
  if (matchingList.length > 0)
    return matchingList[0]
  for (let parentTask of taskList) {
    let task = findTask(parentTask.taskList, taskId)
    if (task)
      return task
  }
  return null
}

export function findTaskByTaskNumber(taskList, taskNumber) {
  if (!taskList)
    return null
  let matchingList = taskList.filter(task => task.taskNumber === taskNumber)
  if (matchingList.length > 0)
    return matchingList[0]
  for (let parentTask of taskList) {
    let task = findTaskByTaskNumber(parentTask.taskList, taskNumber)
    if (task)
      return task
  }
  return null
}

export function findSiblingTasks(topTaskList, task) {
  if (task.parentTaskId) {
    let parentTask = findTask(topTaskList, task.parentTaskId)
    if (!parentTask) { // parentTask was deleted from tree when subtree was deleted
      return null
    }
    return parentTask.taskList
  }
  else {
    return topTaskList
  }
}

export function findParentTasks(topTaskList) {
  let parentTaskList = []
  findParentTasksInner(topTaskList, parentTaskList)
  return parentTaskList
}

function findParentTasksInner(taskList, parentTaskList) {
  taskList.filter(task => task.taskList.length > 0).forEach(task => {
    parentTaskList.push(task)
    findParentTasksInner(task.taskList, parentTaskList)
  })
}

export function findPreviousSiblingTask(topTaskList, task) {
  let siblingTasks = findSiblingTasks(topTaskList, task)
  const index = siblingTasks.findIndex(siblingTask => siblingTask.taskId === task.taskId)
  if (index > 0) {
    return siblingTasks[index-1]
  }
  return null
}

export function printTaskList(caller, taskList) {
  console.log(caller, taskList.map(task => task.taskName))
}

export function printTaskTree(taskList) {
  return printTaskTreeRecursive(taskList, '')
}

export function printTaskTreeRecursive(taskList, indent) {
  if (!taskList)
    return
  taskList.forEach(task => {
    console.log(indent, task.taskName, `[${task.taskList.length}]`, task.parentTaskId !== null, ' (task tree)', task.filtered ? 'X' : 'Y')
    printTaskTreeRecursive(task.taskList, `${indent}  `)
  })
}
